import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FileUploader } from 'react-drag-drop-files';
import { SET_TOAST_OBJECT } from 'store/actions';
import { IconCloudUpload } from '@tabler/icons';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import { Grid, Stack } from '@mui/material';
import PreviewAttachmentBox from './PreviewAttachmentBox';
import SingleAttachment from 'helper/SingleAttachment';
import { MAXIMUM_FILE_LIMIT_TEXT } from 'constants/message';
import { Box } from '@mui/system';
import AttachmentMediaUrl from './AttachmentMediaUrl';
import { checkSizeGreaterThan50Mb, convertBytes, convertBytesCeiled, getAttachmentType, giveSize } from 'helper/string.helper';
const DropZone = ({
    fileTypes,
    isMultiple = false,
    maxCount,
    updateInputFile,
    attachments = [],
    setAttachments = undefined,
    type,
    disableAttachments,
    hideMessage,
    setFormError,
    isFlexDesign,
    isFile,
    maxSize,
    noCheck
}) => {
    const [totalAttachment, setTotalAttachment] = useState(attachments?.length);
    const [uploadedFile, setUploadedFile] = useState([]);
    const dispatch = useDispatch();
    const [newMaxSize, setNewMaxSize] = useState(maxSize || 0);
    let maxSizeInMb = newMaxSize ? newMaxSize * 1024 * 1024 : 5 * 1024 * 1024;
    useEffect(() => {
        if (attachments) {
            let total = 0;
            if (attachments) {
                total = attachments.length;
            }
            if (uploadedFile) {
                total += uploadedFile.length;
            }
            setTotalAttachment(total);
        }
    }, [attachments, setTotalAttachment]);
    const handleChange = (files) => {
        let uploaded = [];
        let totalFile = 0;
        if (isMultiple) {
            totalFile += files.length;
            if (attachments) {
                totalFile += attachments.length;
            }
            if (uploadedFile) {
                uploaded = [...uploadedFile];
                totalFile += uploadedFile.length;
            }
            if (totalFile > maxCount) {
                dispatch({
                    type: SET_TOAST_OBJECT,
                    toastObject: { status: true, variant: 'error', message: MAXIMUM_FILE_LIMIT_TEXT }
                });
                return;
            }
            const fileArray = Array.prototype.slice.call(files);
            fileArray.some((file) => {
                if (uploaded.findIndex((f) => f.name === file.name) === -1) {
                    uploaded.push(file);
                }
            });
        } else {
            totalFile = 1;

            uploaded.push(files);
            // if (setAttachments !== undefined) {
            //     setAttachments([]);
            // }
        }
        if (noCheck) {
            const uploadedFile = uploaded?.[0];
            const name = uploadedFile?.name || '';
            const size = uploadedFile?.size || 0;
            if (getAttachmentType(name).toLowerCase() !== 'mp4') {
                if (checkSizeGreaterThan50Mb(size)) {
                    dispatch({
                        type: SET_TOAST_OBJECT,
                        toastObject: {
                            status: true,
                            variant: 'warning',
                            message: 'File is larger than ' + convertBytesCeiled(50 * 1024 * 1024) + '.'
                        }
                    });
                    return;
                }
            }
        }
        setTotalAttachment(totalFile);
        setUploadedFile(uploaded);
        updateInputFile(uploaded);
    };
    const handleDelete = (id) => {
        let total = 0;
        if (isMultiple && attachments) {
            total += attachments.length;
        }
        if (isMultiple && uploadedFile) {
            let newData = uploadedFile.filter((item, index) => index != id);
            if (newData) {
                setUploadedFile(newData);
                updateInputFile(newData);
                total += newData.length;
                setTotalAttachment(total);
                return;
            }
        }
        setUploadedFile([]);
        updateInputFile(isMultiple ? [] : '');
        setTotalAttachment(total);
    };
    const removeImage = (id) => {
        let total = 0;
        if (isMultiple && uploadedFile) {
            total += uploadedFile.length;
        }
        if (isMultiple && attachments) {
            let newData = attachments.filter((item, index) => index !== id);
            if (newData) {
                setAttachments(newData);
                total += newData.length;
                setTotalAttachment(total);
                return;
            }
        }
        setAttachments([]);
        setTotalAttachment(total);
    };
    const errorSize = convertBytesCeiled(maxSizeInMb);
    const design = () => {
        return (
            <div className="drag-field">
                <div className="drag-icon">
                    <IconCloudUpload size={38} className="icon-primary" />
                    {fileTypes?.length && fileTypes?.includes('CSV') ? (
                        <span className="help-text">
                            Drag and drop or click here to upload CSV <br /> (max {errorSize})
                        </span>
                    ) : (
                        <span className="help-text">Upload PDF, PNG, JPG, MP3, MP4 (max {errorSize})</span>
                    )}
                </div>
            </div>
        );
    };
    return (
        <div className="attachment-wrapper">
            {isFlexDesign && !disableAttachments && (
                <Box>
                    {attachments && attachments.length > 0 && (
                        <Stack flexWrap={'wrap'} flexDirection={'row'} gap={'10px'} p={3}>
                            {attachments.map((item, index) => {
                                return !isFile ? (
                                    <AttachmentMediaUrl
                                        key={`attachment-index${index}`}
                                        fileData={null}
                                        namePath={''}
                                        isFile={false}
                                        path={item}
                                        sizeData={null}
                                        index={index}
                                        deleteImage={handleDelete}
                                        removeImage={removeImage}
                                    />
                                ) : (
                                    <AttachmentMediaUrl
                                        key={`uploadedFile-index${index}`}
                                        isFile={true}
                                        fileData={item}
                                        namePath={item.name}
                                        path={''}
                                        index={index}
                                        deleteImage={handleDelete}
                                        removeImage={removeImage}
                                        sizeData={item.size}
                                    />
                                );
                            })}
                        </Stack>
                    )}

                    {uploadedFile.length && !isFile ? (
                        <Stack flexWrap="wrap" p={3}>
                            {uploadedFile.map((item, index) => {
                                return (
                                    <AttachmentMediaUrl
                                        key={`uploadedFile-index${index}`}
                                        isFile={true}
                                        fileData={item}
                                        namePath={item.name}
                                        path={''}
                                        index={index}
                                        deleteImage={handleDelete}
                                        removeImage={removeImage}
                                        sizeData={item.size}
                                    />
                                );
                            })}
                        </Stack>
                    ) : null}
                </Box>
            )}
            <div className="drag-upload">
                <FileUploader
                    multiple={isMultiple ? true : false}
                    handleChange={handleChange}
                    name="file"
                    types={fileTypes ? fileTypes : ['JPEG', 'PNG', 'GIF', 'mp3', 'MP4', 'mpeg', 'pdf', 'jpg']}
                    maxSize={newMaxSize || 5}
                    children={design()}
                    onSizeError={() => {
                        if (!hideMessage) {
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: {
                                    status: true,
                                    variant: 'warning',
                                    message: 'File is larger than ' + convertBytesCeiled(maxSizeInMb) + '.'
                                }
                            });
                        } else {
                            setFormError('File size is too big. It must be within ' + convertBytesCeiled(maxSizeInMb) + '.');
                        }
                    }}
                    onTypeError={() => {
                        if (!hideMessage) {
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: { status: true, variant: 'warning', message: 'Invalid file type.' }
                            });
                        } else {
                            setFormError('Incorrect file type uploaded. Please upload a CSV.');
                        }
                    }}
                    onDrop={handleChange}
                />
                {(totalAttachment > 0 || uploadedFile.length > 0 || attachments.length > 0) && (
                    <>
                        {!disableAttachments && !isFlexDesign && (
                            <div className="custom-attachment-box">
                                <div className="attachment-header">
                                    <div className="attachment-title">
                                        <AttachmentOutlinedIcon className="icon-gray-fill" />
                                        <span className="font-bold">
                                            {totalAttachment} {totalAttachment === 1 ? 'attachment' : 'attachments'}
                                        </span>
                                    </div>
                                </div>
                                <div className="attachment-body">
                                    <Grid container spacing={0.5}>
                                        {attachments &&
                                            attachments.length > 0 &&
                                            attachments.map((item, index) => {
                                                return (
                                                    <SingleAttachment
                                                        path={item}
                                                        key={index}
                                                        removeImage={() => removeImage(index)}
                                                        preview={false}
                                                    />
                                                );
                                            })}
                                        {uploadedFile.length > 0 &&
                                            !disableAttachments &&
                                            uploadedFile.map((item, index) => {
                                                return (
                                                    <PreviewAttachmentBox
                                                        item={item}
                                                        key={index}
                                                        handleDelete={() => handleDelete(index)}
                                                    />
                                                );
                                            })}
                                    </Grid>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default DropZone;
